import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow",
        outline: "text-foreground",
        /* Status tones. warning/info reuse chart tokens (orange/blue) since
           those hues are unambiguous either way; success gets its own
           dedicated --success token instead (index.css) -- the 5-color
           chart palette has no green in it, so reusing chart-2 here used to
           render every "good" status as orange, not green (caught 2026-09-19). */
        success: "border-transparent bg-[hsl(var(--success)/0.15)] text-[hsl(var(--success))]",
        warning: "border-transparent bg-[hsl(var(--chart-3)/0.18)] text-[hsl(var(--chart-3))]",
        info: "border-transparent bg-[hsl(var(--chart-5)/0.15)] text-[hsl(var(--chart-5))]",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
